import { sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    ellipseRatio: 0.1407
};
/**
 * Represents a Direct Access Storage shape, a flowchart element used to indicate
 * direct access storage devices like magnetic disks. Extends Rectangle with
 * rounded ends.
 */
export class DirectAccessStorage extends Rectangle {
    /**
     * Creates a new DirectAccessStorage instance.
     * @param options - Configuration options for the direct access storage shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the direct access storage shape path as a rounded rectangle with elliptical ends.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const ellipseRX = width * this.options.ellipseRatio;
        const cx = ellipseRX;
        const rx = ellipseRX;
        const ry = height / 2;
        drawingElement
            .moveTo([width - cx, height])
            .arcTo([width - cx, 0], rx, ry, false, true)
            .arcTo([width - cx, height], rx, ry, false, true)
            .lineTo([cx, height])
            .arcTo([cx, 0], rx, ry, false, true)
            .lineTo([width - cx, 0]);
    }
}
